import { mapActions } from 'vuex'
import { GET_REVIEWS } from '@/utils/store/actionTypes'

export default {
  async fetch () {
    // TODO:: revert
    // try {
    //   const { data } = await this.getReviews()
    //   const { reviewSite } = data

    //   this.reviewData.name = reviewSite.altText
    //   this.reviewData.rating = reviewSite.rating
    //   this.reviewData.maxRating = reviewSite.maxRating
    //   this.reviewData.amountReviews = reviewSite.amountReviews
    //   this.reviewData.image = process.env.BASE_S3_PATH + '/' + reviewSite.imagePath
    //   this.reviewData.url = reviewSite.url
    // } catch (e) {
    //   this.$ota.general.logError(e)
    // }
  },
  data () {
    return {
      reviewData: {
        name: null,
        rating: null,
        maxRating: null,
        amountReviews: null,
        image: null,
        url: null
      }
    }
  },
  methods: {
    ...mapActions('app', {
      getReviews: GET_REVIEWS
    })
  }
}
